import { useDispatch, useSelector } from "react-redux";
import { Table } from "src/components";
import { clusterActions } from "src/context/cluster-slice";
import { RootState } from "src/context/store";
import ClusterLayoutComponent from "./cluster-layout.component";
import { getClusterMasterColumns } from "./cluster-master-table.columns";
import { useToast } from "src/hooks/useToast";
import { getAllCompanyDetails } from "src/services/company-api";

const ClusterMasterComponent = () => {
  const { clusterMasterTable } = useSelector((state: RootState) => state.cluster);

  const dispatch = useDispatch();
  const { toast } = useToast();

  const editHandler = async (rowData: any) => {
    try {
      const response = await getAllCompanyDetails();
      const companyData = response?.data;
      if (!Array.isArray(companyData)) throw new Error("Invalid company data");

      const formattedCompanies = companyData?.map((item: any) => ({
        value: item.code,
        label: item.name,
      }));
      dispatch(clusterActions.setCompanyList(formattedCompanies));

      const formData = {
        ...rowData,
        company_code: Array.isArray(formattedCompanies)
          ? formattedCompanies.find((item: any) => item?.value == rowData?.company_code?.code) || null
          : null,
      };
      // Dispatch form data and open modal
      dispatch(clusterActions.setAddEditFormData(formData));
      dispatch(clusterActions.setIsEdit(true));
      dispatch(clusterActions.setShowAddEditForm(true));

    } catch (error) {
      toast({
        title: "Error",
        description: "An error occurred while preparing the form.",
      });
      console.error("editHandler error:", error);
    }
  };

  return (
    <ClusterLayoutComponent>
      <div>
        <Table title="Cluster details" showSearch={true} data={clusterMasterTable || []} columns={getClusterMasterColumns([], editHandler)} />
      </div>
    </ClusterLayoutComponent>
  );
};

export default ClusterMasterComponent;
